import React, {Fragment} from "react";
import {
    Button,
    Col,
    Collapse,
    Descriptions,
    Divider,
    Dropdown,
    List,
    Menu,
    Popconfirm,
    Row,
    Space,
    Tag,
    Tooltip, Typography
} from "antd";
import PermissionHidden from "../../../../components/permissions/PermissionHidden";
import {
    AlertOutlined,
    CommentOutlined,
    CreditCardOutlined,
    DeleteOutlined, EditOutlined,
    EnvironmentOutlined, FieldTimeOutlined, FileOutlined,
    HomeOutlined,
    HourglassOutlined,
    InfoCircleOutlined,
    LinkOutlined,
    MailOutlined,
    MergeCellsOutlined, MinusCircleOutlined,
    NodeIndexOutlined,
    PhoneOutlined,
    PlusOutlined, ReloadOutlined,
    RollbackOutlined, ScheduleOutlined,
    SkinOutlined,
    TagOutlined, VerticalAlignBottomOutlined
} from "@ant-design/icons";
import RestrictedHidden from "../../../../components/permissions/RestrictedHidden";
import {checkForfait} from "../../../../components/permissions/functions";
import {APP_PREFIX_PATH, ASSET_BASE_URL} from "../../../../configs/AppConfig";
import ContactIcon from "../../../../components/util-components/ContactIcon";
import moment from "moment";
import {useSelector} from "react-redux";

const {Text, Title} = Typography

export function FicheShared(props) {

    const org = useSelector(_state => _state.auth.org)

    const {selected} = props

    if (!selected) {
        return null
    }


    if ((!selected?.sharedWith || selected?.sharedWith?.length === 0)) {
        return null
    }


    return (
        <Col style={{marginBottom: 20}}>
            <Row style={{flexWrap: "wrap", justifyContent: "flex-end", marginBottom: 10}}>
                <Space>
                    {selected.sharedWith && selected?.sharedWith?.length > 0 && selected.sharedWith.map(i => {
                        return (
                            <Tag key={i.id}
                                 color={"purple"}>{i.shortName} {selected.owner === i.id && "(Propriétaire)"}</Tag>
                        )
                    })}

                </Space>
            </Row>
        </Col>
    )
}
